// @flow

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_ASSET_ID,
  PROP_PARENT,
} from 'fc-model-assets'

// Libs
export default function getAncestors (assets: AssetsById, assetId: number): Array<Asset> {
  const asset: Asset = assets[assetId]
  let parent = asset && assets[asset[PROP_PARENT]]
  const ancestors = []

  while (parent && parent[PROP_ASSET_ID] && parent[PROP_ASSET_ID] > 1) {
    ancestors.splice(0, 0, parent)
    parent = assets[parent.parent]
  }

  return ancestors
}
